import Page from 'modules/Stories'

export default Page

